import { Component, OnInit} from '@angular/core';
import { first } from 'rxjs/operators';
import { MatDialog } from '@angular/material';

import { AirportSearchResult } from '../../airport/models/airport-search-result.model';
import { AirportService } from '../../airport/airport.service';
import { PromiseState, StatefulPromise } from '../../util/stateful-promise';
import { UserInfo } from '../../shared/models/user-info.model';
import { UserService } from '../../shared/user/user.service';
import { ProcDownloadComponent } from '../proc-download/proc-download.component';


@Component({
  selector: 'app-favorites-list',
  templateUrl: './favorites-list.component.html',
  styleUrls: ['./favorites-list.component.scss']
})
export class FavoritesListComponent implements OnInit {
  airports: Array<AirportSearchResult>;
  favoritesPromise: StatefulPromise<AirportSearchResult[]>;
  userInfo: UserInfo = null;

  constructor(
    private _airports: AirportService,
    private _userService: UserService,
    private _dialog: MatDialog
  ) { }

  ngOnInit() {
    this._userService.userInfo.pipe(first(v => v !== null)).subscribe(e => this._onUserInfoUpdate(e));
  }

  private _onUserInfoUpdate(e: UserInfo) {
    this.userInfo = e;

    let idList = $.map(this.userInfo.favoriteAirports, function(a) {
      return a.identifier;
    }).join();
    if (this.userInfo.homeAirportIdent) {
      idList += ',' + this.userInfo.homeAirportIdent;
    }
    if (idList) {
      this.favoritesPromise = new StatefulPromise(this._airports.getFavoriteAirports(idList));
    } else {
      this.favoritesPromise = null;
    }
  }

  private get _favorites(): Array<AirportSearchResult> {
    if (!this.favoritesPromise || this.favoritesPromise.state !== PromiseState.Fulfilled) {
      return null;
    }
    return this.favoritesPromise.value;
  }

  get favorites(): Array<AirportSearchResult> {
    return this._favorites;
  }

  downloadProcs() {
    this._dialog.open(ProcDownloadComponent, {
      width: '600px',
      height: '740px',
      panelClass: 'proc-download-dialog',
      data: {
        airports: this._favorites
      }
    });
  }
}
